export const STAT_SECTIONS = {
    offensive: {
        title: "Offensive Stats",
        key: "offensive",
        fields: [
            { label: "Goals", key: "goals" },
            { label: "Assists", key: "assists" },
            { label: "Shots", key: "shots" },
            { label: "xG", key: "xg", float: true },
            { label: "xA", key: "xa", float: true },
            { label: "Non-Penalty Goals", key: "np_goals" },
            { label: "npxG", key: "np_xg", float: true },
            { label: "Goals - xG Diff", key: "goals_xg_diff", calculated: true },
            { label: "npG - npxG Diff", key: "np_goals_npxg_diff", calculated: true },
            { label: "Goals per Shot", key: "goals_per_shot", calculated: true },
            { label: "npxG per Shot", key: "npxg_per_shot", calculated: true },
            { label: "Goals per 90", key: "goals_per_90", calculated: true, per90: true },
            { label: "Assists per 90", key: "assists_per_90", calculated: true, per90: true },
            { label: "xG per 90", key: "xg_per_90", calculated: true, per90: true },
            { label: "xA per 90", key: "xa_per_90", calculated: true, per90: true },
            { label: "Shots per 90", key: "shots_per_90", calculated: true, per90: true },
        ],
    },
    defensive: {
        title: "Defensive Stats",
        key: "defensive",
        fields: [
            { label: "Tackles Won", key: "tackles_won" },
            { label: "Interceptions", key: "interceptions" },
            { label: "Duels Won", key: "duels_won" },
            { label: "Total Defensive Actions", key: "total_def_actions", calculated: true },
            { label: "Tackles per 90", key: "tackles_per_90", calculated: true, per90: true },
            { label: "Interceptions per 90", key: "interceptions_per_90", calculated: true, per90: true },
            { label: "Duels Won per 90", key: "duels_won_per_90", calculated: true, per90: true },
            { label: "Def. Actions per 90", key: "def_actions_per_90", calculated: true, per90: true },
        ],
    },
    keepers: {
        title: "Goalkeeping Stats",
        key: "keepers",
        fields: [
            { label: "Saves", key: "saves" },
            { label: "Goals Conceded", key: "goals_conceded" },
            { label: "Clean Sheets", key: "clean_sheet" },
            { label: "Punches", key: "punches" },
            { label: "High Claims", key: "high_claims" },
            { label: "Recoveries", key: "recoveries" },
            { label: "Touches", key: "touches" },
            { label: "Accurate Passes", key: "passes_accurate" },
            { label: "Accurate Long Balls", key: "long_balls_accurate" },
            { label: "Goals Prevented", key: "goals_prevented", float: true },
            { label: "xGOT Faced", key: "xgot_faced", float: true },
            { label: "Save %", key: "save_percent", calculated: true },
            { label: "Saves per 90", key: "saves_per_90", calculated: true, per90: true },
            { label: "Goals Conceded per 90", key: "goals_conceded_per_90", calculated: true, per90: true },
        ],
    },
};
